import { Button, Checkbox, Form, Input, message } from "antd";

import styles from "./CreateWordForm.module.css";
import { useForm } from "antd/es/form/Form";
import { CRITERIA_OPTIONS } from "../../../utils/constants";
import { wordsFetcher } from "../../../services/api";
import { WordInput, Word } from "../../../types/words";
import { useState } from "react";

const { TextArea } = Input;

interface CreateWordFormProps {
  onWordCreated?: () => void;
  existingWords?: Word[];
}

const CreateWordForm = ({ onWordCreated, existingWords = [] }: CreateWordFormProps) => {
    const [form] = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        try {
            const values = await form.validateFields();
            
            const wordExists = existingWords.some(existingWord => 
                existingWord.word.toLowerCase() === values.word.toLowerCase()
            );
            
            if (wordExists) {
                message.error("Error al crear paraula. Aquesta paraula ja existeix a la llista blanca.");
                return;
            }
            
            setLoading(true);
            
            const wordData: WordInput = {
                id: "",
                word: values.word,
                criteria: values.criteria,
                additional_info: values.additional_info || undefined,
            };

            await wordsFetcher.createWord(wordData);
            
            message.success("Paraula creada correctament");
            form.resetFields();
            onWordCreated?.();
            
        } catch (error) {
            console.error("Error creating word:", error);
            message.error("Error al crear la paraula. Si us plau, torna-ho a intentar.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" requiredMark={"optional"}>
            <h4 className={`head4 ${styles.modalTitle}`}>Panell de creació de paraules</h4>
            <Form.Item
                label={<strong>Paraula</strong>}
                name="word"
                rules={[{ required: true, message: "Aquest camp és obligatori, si us plau Completar" }]}
            >
                <Input placeholder="Escriu una o diverses paraules" />
            </Form.Item>
            <Form.Item
                label={<strong>Criteris d'anonimització</strong>}
                name="criteria"
                rules={[{ required: true, message: "Aquest camp és obligatori, si us plau Completar" }]}
            >
                <Checkbox.Group>
                    <div className={styles.checkboxeGroup}>
                        {CRITERIA_OPTIONS.map((option) => (
                            <Checkbox key={option.value} value={option.value} className={styles.checkbox}>
                            {option.label}
                            </Checkbox>
                        ))}
                    </div>
                </Checkbox.Group>
            </Form.Item>
            <Form.Item
                label={<strong>Informació addicional</strong>}
                name="additional_info"
            >
                <TextArea rows={4} placeholder="Agrega informació específica" maxLength={300} />
            </Form.Item>
            <Button loading={loading} onClick={onSubmit} type="primary" block>Crear</Button>
        </Form>
    );
};

export default CreateWordForm;
